import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PHARMACY_WALLET } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// API: GET /api/v1/pharmacy/wallet/balance
export const fetchPharmacyWalletReducer = createAsyncThunk(
  ACTION_PHARMACY_WALLET.fetch_pharmacy_wallet,
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacyWallet}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        console.log("Pharmacy Wallet Response:", response.data.data);
        return response.data.data;
      } else {
        const msg =
          response?.data?.message || i18n.t("pharmacy.toast.failedToFetchPharmacyWalletDetails");
        toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error fetching pharmacy wallet:", error);

      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorFetchingPharmacyWalletDetails");

      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
